import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Attachment} from "../../../attachments/models/attachment.model";

export class BringozImagesViewerComponent implements IController {

  attachments: Attachment[];
  height: any;
  onUploadImage: Function;

  public currentViewedAttachment: Attachment;
  public currentViewedImageIndex: number;
  public totalImages: number;
  public canUpload: boolean;
  public pattern = "'.pdf,.tif,.tiff,.bmp,.jpeg,.jpg,.gif,.png,.eps,.raw,.cr2,.nef,.orf,.sr2'"

  constructor() {
  }

  $onInit() {

    this.currentViewedAttachment = this.attachments[0];
    if (this.attachments?.length) {
      this.currentViewedImageIndex = 0;
    }
    this.totalImages = this.attachments?.length;

    this.canUpload = _.isFunction(this.onUploadImage)
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.attachments && !changes.attachments.isFirstChange()) {
      this.$onInit();
    }
  }

  nextImage() {
    const nextIndex = (this.currentViewedImageIndex + 1) === this.attachments.length ? 0 : this.currentViewedImageIndex + 1;
    this.currentViewedAttachment = this.attachments[nextIndex]
    this.currentViewedImageIndex = nextIndex;
  }

  previousImage() {
    const nextIndex = this.currentViewedImageIndex ? this.currentViewedImageIndex - 1 : this.attachments.length - 1;
    this.currentViewedAttachment = this.attachments[nextIndex]
    this.currentViewedImageIndex = nextIndex;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozImagesViewer', {
    bindings: {
      attachments: '<',
      height: '<?',
      onUploadImage: '&?'
    },
    template: require('./bringoz-images-viewer.html').default,
    controller: BringozImagesViewerComponent
  });
